import {
    GET_ASSET_ITEM_STATUS_VENDOR_DETAIL,
    SET_ASSET_ITEM_STATUS_VENDOR_DETAIL,
    SET_IS_ASSET_ITEM_STATUS_VENDOR_DETAIL_CALLED
} from "./AssetItemStatusVendorDetailType"

const getAssetItemStatusVendorDetail = (fleetDetailId: any) => ({
    type: GET_ASSET_ITEM_STATUS_VENDOR_DETAIL,
    fleetDetailId
})

const setAssetItemStatusVendorDetail = (assetItemStatusVendorDetail: any) => ({
    type: SET_ASSET_ITEM_STATUS_VENDOR_DETAIL,
    assetItemStatusVendorDetail: assetItemStatusVendorDetail
})

const SetIsAssetItemStatusVendorDetailCalled = (fleetDetailId : any , isLoading : any) => {
    return {
      type: SET_IS_ASSET_ITEM_STATUS_VENDOR_DETAIL_CALLED,
      fleetDetailId,
      isLoading: isLoading
    };
}

export {
    getAssetItemStatusVendorDetail,
    setAssetItemStatusVendorDetail,
    SetIsAssetItemStatusVendorDetailCalled
}